<div class="container-fluid admin-form-page">
  <form class="admin-form" (ngSubmit)="createArticle()" ngNativeValidate>
    <div class="row section1">
      <div class="col-12 col-md-7 col-lg-7 col-xl-7">
        <div class="home-details">
          <h5 class="home-title">Create new Article</h5>
          <p class="home-subtitle">Fill all the below fields (Fields with *are mendatory)</p>
        </div>
      </div>
      <div class="col-12 col-md-7 col-lg-5 col-xl-5">
        <div class="dashboard-btn dashboard-manage admin-page-actions">
          <button type="button" class="btn btn-primary btn-dashboard" (click)="goBack()">Back</button>
          <button class="btn btn-primary btn-dashboard">Create Article</button>
        </div>
      </div>
    </div>

    <div class="section1">
      <div class="applicants-details details1 admin-form-card">
        <div class="row align-items-center">
          <div class="col-1 ">
            <div class="user-form">
              <div class="form-group d-flex flex-column">
                <label>Choose image*</label>
                @if (thumbnail) {
                  <img class="position-relative " style="object-fit: cover" width="100" height="100"
                    src="{{thumbnail}}" alt="">
                }
                @if (!thumbnail) {
                  <img class="position-relative " style="object-fit: cover" width="100"
                    height="100"
                    src="assets/images/placeholder.png" alt="">
                  }
                  @if (!thumbnail && !uploading) {
                    <i (click)="handleClickUpload()"
                    class="las font-size-16 la-plus-circle img-icon"></i>
                  }
                  @if (thumbnail && !uploading) {
                    <i (click)="handleClickUpload()"
                    class="las font-size-16 la-pencil-alt img-icon"></i>
                  }
                  @if (uploading) {
                    <div class="img-icon-loader">
                      <img src="assets/images/loading.gif" width="40" alt="">
                    </div>
                  }
                </div>
                <input id="dp" name="file-upload-field" type="file"
                  accept=".png, .jpg, .jpeg, .webp"
                  class="form-control d-none"
                  (change)="uploadImage($event)" required>
              </div>
            </div>
            <div class="col-4">
              <div class="user-form">
                <div class="form-group">
                  <label for="title">Title*</label>
                  <input type="text" class="form-control" id="title" [(ngModel)]="article.title" name="title"
                    placeholder="Enter Title" required>
                </div>
              </div>
            </div>
            <div class="col-3">
              <div class="user-form">
                <div class="form-group">
                  <label for="type">Type</label>
                  <select [(ngModel)]="article.type" id="type" class="form-control" name="type" required>
                    <option value="1">Opinion</option>
                    <option value="2">Article</option>
                    <option value="3">News</option>
                  </select>
                </div>
              </div>
            </div>
            <div class="col-4">
              <div class="user-form">
                <div class="form-group">
                  <label for="short-description">Short Description*</label>
                  <input type="text" class="form-control" [(ngModel)]="article.shortDescription" name="short-description"
                    placeholder="Enter Short Description" id="short-description" required>
                </div>
              </div>
            </div>
            <div class="col-12 ">
              <div class="user-form">
                <div class="form-group">
                  <label>Description</label>
                  <angular-editor placeholder="Enter Description" name="description"
                    [(ngModel)]="article.description" id="description" [config]="editorConfig">
                  </angular-editor>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </form>
  </div>
